import { action, SB } from '@play-co/replicant';
import { getDynamicTestBucket } from '../getters/ab';
import ab from '../ruleset/ab';
import features from '../ruleset/features';

import createActions from './utils/createActions';

const testIdSchema = SB.string().customValidator((testId) => {
  if (!(testId in ab.config)) {
    return `Invalid test ID: '${testId}'`;
  }

  return '';
});

const abTestsSchema = SB.map(SB.string()).customValidator((value) => {
  const testIdErrors = Object.keys(value)
    .map((testId) => testIdSchema.validate(testId))
    .filter((error) => !!error)
    .join('\n');

  if (testIdErrors) {
    return testIdErrors;
  }

  if (
    Object.entries(value).some(
      ([testId, bucketId]) =>
        !ab.config[testId].buckets.find((bucket) => bucket.id === bucketId),
    )
  ) {
    return 'Invalid bucket ID';
  }

  return '';
});

type AbTests = SB.ExtractType<typeof abTestsSchema>;

export default createActions({
  setAbTests: action((state, args: AbTests) => {
    abTestsSchema.tryValidate(args);

    state.abTests = args;
  }),

  addAbTests: action((state, args: AbTests) => {
    abTestsSchema.tryValidate(args);

    for (const test in args) {
      state.abTests[test] = args[test];
    }
  }),

  assignManualAbTests: action((state, _: void, api) => {}),
});
